import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import config from '../../config.json'
import { MOVIE } from '../../constants/itemTypes'
import toJS from '../../hoc/toJS';
import hasMovies from '../../hoc/hasMovies';
import ListDrag from '../../components/DragAndDropList/presents/ListDrag';
import dndItemTypes from '../../constants/dndItemTypes';
import canEditProgram from '../../functions/canEditProgram';
import { Link, withRouter } from 'react-router-dom'
import ProgramDragDropItemSwitch from '../../components/PageEditSelection/ProgramDragDropItemSwitch'
import getData from '../../functions/getData';
import { AUTH_CAPS } from '../../constants/state';
import Translation from '../../components/Translation/cont/Translation'

const mapStateToProps = state => ({
    caps: getData(state, AUTH_CAPS)
})


const ProgramListMoviesContainer = ({
    titleTransId, 
    className, 
    items, 
    order, 
    match,
    caps,
    isAllOpen,
    setAllOpen,
}) => {
    const { selectionId, selectionType } = match.params
    const basicUrl = `${config.routes.program.path}/${selectionType}/${selectionId}`
    const canEdit = canEditProgram(caps)


    return <ListDrag
        titleTransId={titleTransId}
        listId={'movie-' + selectionId}
        dndType={dndItemTypes.PROGRAM_ITEM_AD}
        className={className}

        type={MOVIE}

        order={order}
        items={items}

        ChildSwitchItem={ProgramDragDropItemSwitch}

        params={false}
        basicUrl={basicUrl}

        defaultIsOpen={isAllOpen}
        setAllOpen={setAllOpen}

        canEdit={canEdit}
        canDelete={false}
    >
        <Link className="sorting-link text-xsmall-light" to={`${config.routes.program.path}/${selectionType}/${selectionId}/sortierung`}>
            <Translation id="movie_sort_movies">Filme sortieren</Translation>
        </Link>
    </ListDrag>
}

export default compose(
    withRouter,
    hasMovies(),
    connect(mapStateToProps, null),
    toJS()
)(ProgramListMoviesContainer)